<template>
  <view class="container">
    <!-- View 1: Catalog (画册) - Sidebar Layout -->
    <view class="view-content catalog-view" wx:if="{{currentTab === 'catalog'}}">
      <!-- Dynamic Banner Swiper replaces Title -->
      <view class="banner-container" wx:if="{{bannerList && bannerList.length > 0}}">
        <swiper class="banner-swiper" indicator-dots="{{bannerList.length > 1}}" autoplay circular interval="3000" indicator-active-color="#2ba471">
          <swiper-item wx:for="{{bannerList}}" wx:key="*this">
            <image src="{{item}}" class="banner-image" mode="aspectFill" />
          </swiper-item>
        </swiper>
      </view>
      <view class="web-navbar" wx:else>
        <view class="navbar-title">{{isShareMode && sharedCompanyInfo ? sharedCompanyInfo.name + ' 的产品画册' : (settings.catalog_banner_title || '产品画册')}}</view>
      </view>
      
      <!-- Share Banner -->
      <view class="share-banner" wx:if="{{isShareMode && sharedCompanyInfo}}" style="background: #f0fdf4; padding: 20rpx 32rpx; display: flex; align-items: center; border-bottom: 1rpx solid #dcfce7;">
        <view class="banner-badge" style="background: #2ba471; color: #fff; font-size: 20rpx; padding: 4rpx 12rpx; border-radius: 6rpx; margin-right: 16rpx;">合作商推荐</view>
        <text style="font-size: 26rpx; color: #2ba471; font-weight: 600;">{{sharedCompanyInfo.name}}</text>
      </view>
      
      <view class="catalog-layout">
        <!-- Left Sidebar: Categories -->
        <scroll-view scroll-y class="sidebar" show-scrollbar="{{false}}">
          <view 
            wx:for="{{categoryList}}" 
            wx:key="id" 
            class="sidebar-item {{activeCategory === item.id ? 'active' : ''}}"
            bindtap="onCategoryChange"
            data-id="{{item.id}}"
          >
            {{item.name}}
          </view>
        </scroll-view>

        <!-- Right Content: Products -->
        <scroll-view scroll-y class="main-content" show-scrollbar="{{false}}">
          <view class="product-list-vertical">
            <view class="product-item-row" wx:for="{{displayProducts}}" wx:key="id">
              <view class="prod-main-row">
                <image class="prod-img" src="{{item.images[0]}}" mode="aspectFill" />
                <view class="prod-info">
                  <view class="prod-name">{{item.name}}</view>
                  
                  <!-- Expanded Tags Row -->
                  <view class="prod-tags">
                    <text class="tag primary" wx:if="{{item.spec}}">{{item.spec}}</text>
                    <text class="tag" wx:if="{{item.shelfLife}}">保质期:{{item.shelfLife}}</text>
                    <text class="tag" wx:if="{{item.cartonSpec}}">规:{{item.cartonSpec}}</text>
                    <text class="tag red" wx:if="{{item.minOrder}}">起订:{{item.minOrder}}</text>
                    
                    <block wx:if="{{item.tags && item.tags.length}}">
                      <text 
                        class="tag {{ (t === 'OEM' || t === '京东挂价' || t === '免费设计') ? 'oem' : 'custom' }}" 
                        wx:for="{{item.tags}}" 
                        wx:for-item="t" 
                        wx:key="*this"
                      >{{t}}</text>
                    </block>
                  </view>
  
                  <view class="prod-desc-container" bindtap="toggleDesc" data-id="{{item.id}}">
                    <view class="prod-desc {{expandedIds[item.id] ? 'expanded' : ''}}">{{item.features || item.description || '暂无描述'}}</view>
                    <view class="expand-btn" wx:if="{{(item.features || item.description).length > 40}}">{{expandedIds[item.id] ? '收起' : '展开详情'}}</view>
                  </view>
                  
                  <view class="prod-bottom">
                    <view class="price-box">
                      <text class="unit">¥</text>
                      <text class="price">{{item._priceStr || '0.00'}}</text>
                    </view>
                    <!-- Toggle Product (Simplified for Gallery Mode) -->
                    <view class="gallery-toggle" wx:if="{{!isShareMode}}">
                      <view class="btn-toggle {{cartMap[item.id] ? 'active' : ''}}" bindtap="toggleCart" data-id="{{item.id}}">
                        {{cartMap[item.id] ? '已加入' : '加入清单'}}
                      </view>
                    </view>
                    <view class="view-only-tag" wx:else style="font-size: 22rpx; color: #86909c; background: #f2f3f5; padding: 4rpx 12rpx; border-radius: 4rpx;">只读预览</view>
                  </view>
                </view>
              </view>
            </view>
          </view>
          <view class="no-more" wx:if="{{(displayProducts || []).length > 0}}">到底啦</view>
          <view class="empty-state" wx:else>暂无产品</view>
        </scroll-view>
      </view>
    </view>

    <!-- View 2: Cart Page -->
    <view class="view-content" wx:if="{{currentTab === 'cart'}}">
        <view class="web-navbar">
            <view class="navbar-title">
              {{sharedCompanyInfo ? sharedCompanyInfo.name + '的选购清单' : '选购清单'}} ({{(cart || []).length}})
            </view>
        </view>
        <scroll-view scroll-y class="cart-scroll-list">
          <view class="cart-item" wx:for="{{cart}}" wx:key="productId">
              <image class="cart-img" src="{{item.product.images[0]}}" mode="aspectFill" />
              <view class="cart-info">
                  <view class="cart-name">{{item.product.name}}</view>
                  <view class="cart-spec" wx:if="{{item.product.spec}}">{{item.product.spec}}</view>
                  <view class="cart-price-row">
                      <text class="c-price">¥{{item.product._priceStr}}</text>
                      <view class="btn-delete" bindtap="addToCart" data-id="{{item.productId}}" data-q="{{-item.quantity}}" wx:if="{{!isShareMode}}">移除</view>
                  </view>
              </view>
          </view>
        </scroll-view>
        <view class="cart-footer" wx:if="{{(cart || []).length > 0}}">
            <view class="total"><text>共</text><text class="price">{{(cart || []).length}}</text><text>件商品</text></view>
            <view class="footer-actions" wx:if="{{!isShareMode}}">
              <view class="btn default" bindtap="clearCart">清空</view>
              <view class="btn primary {{hasInvalidItems ? 'disabled' : ''}}" bindtap="onShare">生成清单</view>
            </view>
            <view class="footer-actions" wx:else>
              <view class="btn primary" bindtap="onNativeTabChange" data-val="profile">联系合作商</view>
            </view>
          </view>
      </view>

      <!-- View 3: Contact/User Page -->
      <view class="view-content" wx:if="{{currentTab === 'profile'}}">
          <view class="web-navbar">
              <view class="navbar-title">个人中心</view>
              <view class="navbar-action" wx:if="{{agentInfo}}" bindtap="onLogout">退出</view>
          </view>
          
          <view class="contact-container" style="flex: 1; overflow-y: auto;">
              
              <!-- Scenario 2: Shared Link (Not Logged In, Has Shared Company) -->
              <block wx:if="{{isShareMode && localSharedCompany && !agentInfo && !showLoginForm}}">
                <view class="shared-company-card" style="margin: 20rpx; padding: 40rpx; background: #fff; border-radius: 24rpx; box-shadow: 0 4rpx 20rpx rgba(0,0,0,0.05);">
                  <view class="card-header" style="display: flex; align-items: center; margin-bottom: 32rpx;">
                    <view class="company-logo" style="width: 100rpx; height: 100rpx; background: #f0f7ff; color: #0052d9; border-radius: 20rpx; display: flex; align-items: center; justify-content: center; font-size: 40rpx; font-weight: bold; margin-right: 24rpx;">{{localSharedCompany.name[0] || 'C'}}</view>
                    <view class="company-info">
                      <view class="company-name" style="font-size: 34rpx; font-weight: 700; color: #1d1d1f;">{{localSharedCompany.name}}</view>
                      <view class="company-desc" style="font-size: 24rpx; color: #86909c; margin-top: 4rpx;">为您提供选购服务推荐</view>
                    </view>
                  </view>
                  
                  <view class="info-group" style="padding: 24rpx 0; border-top: 1rpx solid #f2f3f5;">
                    <view class="info-item" wx:if="{{localSharedCompany.contactName}}" style="display: flex; justify-content: space-between; margin-bottom: 20rpx;">
                      <view class="label" style="font-size: 26rpx; color: #86909c;">联系人</view>
                      <view class="value" style="font-size: 26rpx; color: #1d1d1f; font-weight: 500;">{{localSharedCompany.contactName}}</view>
                    </view>
                    <view class="info-item" wx:if="{{localSharedCompany.phone}}" style="display: flex; justify-content: space-between;">
                      <view class="label" style="font-size: 26rpx; color: #86909c;">联系电话</view>
                      <view class="value" style="font-size: 26rpx; color: #2ba471; font-weight: 500;">{{localSharedCompany.phone}}</view>
                    </view>
                  </view>
                </view>

                <view class="agent-login-prompt" style="margin-top: 60rpx; text-align: center; border-top: 1rpx solid #f0f0f0; padding: 40rpx 0;">
                  <view class="prompt-text" style="font-size: 24rpx; color: #86909c;">您是合作商?</view>
                  <view class="login-btn-secondary" bindtap="showAgentLogin" style="font-size: 26rpx; color: #2ba471; margin-top: 12rpx; font-weight: 600; display: inline-block; padding: 12rpx 32rpx; border: 1rpx solid #2ba471; border-radius: 30rpx;">合作商登录</view>
                </view>
              </block>

              <!-- Scenario 3: Agent Logged In -->
              <block wx:elif="{{agentInfo}}">
                <view class="agent-card">
                    <view class="agent-logo">{{agentInfo.name[0] || '?'}}</view>
                    <view class="agent-info">
                        <view class="agent-name">{{agentInfo.name}}</view>
                        <view class="agent-desc">合作商编号: {{agentInfo.uid}}</view>
                    </view>
                </view>

                <view class="section-header" style="display: flex; justify-content: space-between; align-items: center; margin: 32rpx 12rpx 20rpx;">
                  <view class="section-title" style="font-size: 24rpx; color: #86909c; font-weight: 600; text-transform: uppercase;">下单公司信息</view>
                  <view class="add-btn" bindtap="{{myCompany ? 'onEditMyCompany' : 'onAddCompany'}}" style="font-size: 26rpx; color: #2ba471; font-weight: 600; border: 2rpx solid #2ba471; padding: 8rpx 24rpx; border-radius: 12rpx;">{{myCompany ? '编辑' : '+ 添加公司'}}</view>
                </view>

                <view class="info-group" wx:if="{{myCompany}}">
                    <view class="info-item company-card" style="display: flex; align-items: center;">
                        <view class="company-main" style="flex: 1;">
                          <view class="company-name">{{myCompany.name}}</view>
                          <view class="company-sub" wx:if="{{myCompany.contactName}}" style="font-size: 24rpx; color: #86909c; margin-top: 4rpx;">{{myCompany.contactName}} {{myCompany.phone}}</view>
                        </view>
                    </view>
                </view>
                <view class="empty-company" wx:else style="padding: 100rpx 0; text-align: center;">
                  <view class="empty-text" style="font-size: 28rpx; color: #c9cdd4;">暂无公司信息,请先添加</view>
                </view>
              </block>

              <!-- Scenario 1: Direct Access (Not Logged In, No Shared Company) -->
              <block wx:else>
                <view class="login-section" style="padding: 80rpx 40rpx; display: flex; flex-direction: column; align-items: center;">
                  <view class="login-header" style="text-align: center; margin-bottom: 80rpx;">
                    <view class="login-logo" style="width: 120rpx; height: 120rpx; background: #2ba471; color: #fff; border-radius: 30rpx; display: flex; align-items: center; justify-content: center; font-size: 60rpx; font-weight: bold; margin: 0 auto 32rpx; box-shadow: 0 8rpx 24rpx rgba(43, 164, 113, 0.2);">T</view>
                    <view class="login-title" style="font-size: 40rpx; font-weight: 700; color: #1d1d1f; margin-bottom: 16rpx;">合作商登录</view>
                    <view class="login-subtitle" style="font-size: 26rpx; color: #86909c;">请输入您的识别码以管理公司和清单</view>
                  </view>
                  <view class="login-form" style="width: 100%;">
                    <input class="login-input" placeholder="请输入识别码 (UID)" value="{{loginUid}}" bindinput="onUidInput" style="background: #fff; height: 100rpx; border-radius: 20rpx; padding: 0 32rpx; font-size: 30rpx; margin-bottom: 32rpx; box-shadow: 0 4rpx 16rpx rgba(0, 0, 0, 0.05); border: 2rpx solid transparent;" />
                    <view class="login-btn {{!loginUid ? 'disabled' : ''}}" bindtap="onLogin" style="height: 100rpx; background: #2ba471; color: #fff; border-radius: 20rpx; display: flex; align-items: center; justify-content: center; font-size: 32rpx; font-weight: 600;">立即登录</view>
                    
                    <!-- Divider -->
                    <view class="login-divider">
                      <view class="divider-line"></view>
                      <text class="divider-text">或</text>
                      <view class="divider-line"></view>
                    </view>
                    
                    <!-- WeChat Login -->
                    <view class="wechat-login-btn" bindtap="onWechatLogin">
                      <image class="wechat-icon" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2307C160'%3E%3Cpath d='M8.5 11c.8 0 1.5-.7 1.5-1.5S9.3 8 8.5 8 7 8.7 7 9.5 7.7 11 8.5 11zm7 0c.8 0 1.5-.7 1.5-1.5S16.3 8 15.5 8 14 8.7 14 9.5s.7 1.5 1.5 1.5zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8 0-1.4.4-2.8 1-3.9.8.3 1.6.4 2.5.4 3.9 0 7-3.1 7-7 0-.9-.2-1.7-.4-2.5C18.8 4.4 20 8 20 12c0 4.4-3.6 8-8 8z'/%3E%3C/svg%3E" />
                      <text>微信授权登录</text>
                    </view>
                  </view>
                </view>
              </block>
          </view>
      </view>
    </view>

    <!-- Company Form Modal -->
    <view class="modal-mask" wx:if="{{showCompanyModal}}" bindtap="closeModal">
      <view class="modal-content" catchtap="stop">
        <view class="modal-header">
          <text>{{editingCompanyId ? '编辑公司' : '新增公司'}}</text>
          <view class="close-icon" bindtap="closeModal">×</view>
        </view>
        <view class="modal-body">
          <view class="form-item">
            <text class="form-label">公司名称</text>
            <input class="form-input" placeholder="请输入公司全称" value="{{companyForm.name}}" bindinput="onFormInput" data-key="name" />
          </view>
          <view class="form-item">
            <text class="form-label">联系人</text>
            <input class="form-input" placeholder="请输入联系人姓名" value="{{companyForm.contactName}}" bindinput="onFormInput" data-key="contactName" />
          </view>
          <view class="form-item">
            <text class="form-label">联系电话</text>
            <input class="form-input" placeholder="请输入联系电话" value="{{companyForm.phone}}" bindinput="onFormInput" data-key="phone" />
          </view>
        </view>
        <view class="modal-footer">
          <view class="btn default" bindtap="closeModal">取消</view>
          <view class="btn primary {{!companyForm.name ? 'disabled' : ''}}" bindtap="submitCompany">保存</view>
        </view>
      </view>
    </view>

    <!-- Navigation TabBar (Enhanced Implementation) -->
    <view class="custom-tab-bar">
      <view class="tab-item {{currentTab === 'catalog' ? 'active' : ''}}" bindtap="onNativeTabChange" data-val="catalog">
        <image class="tab-icon-img" src="{{currentTab === 'catalog' ? tabIcons.catalog.active : tabIcons.catalog.normal}}" />
        <text class="tab-text">画册</text>
      </view>
      <view class="tab-item {{currentTab === 'cart' ? 'active' : ''}}" wx:if="{{agentInfo}}" bindtap="onNativeTabChange" data-val="cart">
        <view class="tab-icon-wrapper">
            <image class="tab-icon-img" src="{{currentTab === 'cart' ? tabIcons.cart.active : tabIcons.cart.normal}}" />
            <view class="badge" wx:if="{{(cart || []).length > 0}}">{{(cart || []).length}}</view>
        </view>
        <text class="tab-text">清单</text>
      </view>
      <view class="tab-item {{currentTab === 'profile' ? 'active' : ''}}" bindtap="onNativeTabChange" data-val="profile">
        <image class="tab-icon-img" src="{{currentTab === 'profile' ? tabIcons.user.active : tabIcons.user.normal}}" />
        <text class="tab-text">我的</text>
      </view>
    </view>
  </view>
</template>

<script>
  import mpx, { createPage } from '@mpxjs/core'
  import store from '../../store'

  createPage({
    data: {
      currentTab: 'catalog',
      activeCategory: 'all',
      forceLoaded: false,
      localProducts: [],
      localCategories: [],
      localCart: [],
      localSharedCart: [], // 存储从分享加载的固定清单
      localSharedCompany: null, // 存储分享过来的公司信息
      shareId: '', // 当前是否处于分享模式
      loginUid: '',
      showLoginForm: false, // 控制是否显示登录表单
      showCompanyModal: false,
      editingCompanyId: null,
      companyForm: {
        name: '',
        contactName: '',
        phone: ''
      },
      expandedIds: {} // 记录展开的商品 ID
    },
    computed: {
      isShareMode() {
        return !!this.shareId
      },
      agentInfo() {
        return store.state.agentInfo
      },
      products() {
        return this.localProducts || []
      },
      categories() {
        return this.localCategories || []
      },
      companies() {
        return store.state.companies || []
      },
      myCompany() {
        const companies = store.state.companies || []
        return companies.length > 0 ? companies[0] : null
      },
      selectedCompanyId() {
        return store.state.selectedCompanyId
      },
      sharedCompanyInfo() {
        return store.state.sharedCompanyInfo
      },
      settings() {
        return store.state.settings || {}
      },
      bannerList() {
        const banners = this.settings.catalog_banners
        if (typeof banners === 'string') {
          try {
            return JSON.parse(banners)
          } catch (e) {
            return [banners]
          }
        }
        return Array.isArray(banners) ? banners : []
      },
      cart() {
        // 分享模式下使用 sharedCart，普通模式使用个人 cart
        const cartState = this.isShareMode ? (this.localSharedCart || []) : (this.localCart || [])
        const productsState = this.localProducts || []
        return cartState.map(item => {
            const product = productsState.find(p => String(p.id) === String(item.productId))
            return {
                ...item,
                product: product ? { ...product, _priceStr: Number(product.price || 0).toFixed(2) } : { name: '未知商品', price: 0, _priceStr: '0.00', images: [] }
            }
        })
      },
      cartMap() {
        const map = {}
        const cartState = this.isShareMode ? (this.localSharedCart || []) : (this.localCart || [])
        cartState.forEach(i => { map[i.productId] = i.quantity })
        return map
      },
      categoryList() {
        const rawCategories = this.localCategories || []
        const rawProducts = this.localProducts || []
        
        if (this.isShareMode) {
          // 在分享模式下，只显示包含分享商品的分类
          const sharedProductIds = (this.localSharedCart || []).map(i => String(i.productId))
          const sharedProducts = rawProducts.filter(p => sharedProductIds.includes(String(p.id)))
          const activeCategoryIds = [...new Set(sharedProducts.map(p => String(p.category)))]
          
          const filteredCategories = rawCategories.filter(c => activeCategoryIds.includes(String(c.id)))
          return [{ id: 'all', name: '全部推荐' }, ...filteredCategories]
        }
        
        return [{ id: 'all', name: '全部' }, ...rawCategories]
      },
      displayProducts() {
        const allProducts = this.localProducts || []
        let products = allProducts
        
        // 分享模式下，只显示分享的商品内容
        if (this.isShareMode) {
          const sharedIds = (this.localSharedCart || []).map(i => String(i.productId))
          products = allProducts.filter(p => sharedIds.includes(String(p.id)))
        }

        const list = this.activeCategory === 'all'
            ? products
            : products.filter(p => String(p.category) === String(this.activeCategory))
        return list.map(p => ({
            ...p,
            _priceStr: Number(p.price || 0).toFixed(2)
        }))
      },
      totalPrice() {
        // 由于不需要数量，这里返回选中商品的总种类价格之和
        const cart = this.cart || []
        return cart.reduce((sum, item) => sum + (item.product.price || 0), 0).toFixed(2)
      },
      hasInvalidItems() {
        const cart = this.cart || []
        return cart.some(i => i.product && i.product.name === '未知商品')
      },
      tabIcons() {
          return {
              catalog: {
                  normal: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjciIGhlaWdodD0iNyI+PC9yZWN0PjxyZWN0IHg9IjE0IiB5PSIzIiB3aWR0aD0iNyIgaGVpZ2h0PSI3Ij48L3JlY3Q+PHJlY3QgeD0iMTQiIHk9IjE0IiB3aWR0aD0iNyIgaGVpZ2h0PSI3Ij48L3JlY3Q+PHJlY3QgeD0iMyIgeT0iMTQiIHdpZHRoPSI3IiBoZWlnaHQ9IjciPjwvcmVjdD48L3N2Zz4=',
                  active: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzJiYTQ3MSIgc3Ryb2tlPSIjMmJhNDcxIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjciIGhlaWdodD0iNyI+PC9yZWN0PjxyZWN0IHg9IjE0IiB5PSIzIiB3aWR0aD0iNyIgaGVpZ2h0PSI3Ij48L3JlY3Q+PHJlY3QgeD0iMTQiIHk9IjE0IiB3aWR0aD0iNyIgaGVpZ2h0PSI3Ij48L3JlY3Q+PHJlY3QgeD0iMyIgeT0iMTQiIHdpZHRoPSI3IiBoZWlnaHQ9IjciPjwvcmVjdD48L3N2Zz4='
              },
              cart: {
                  normal: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iOSIgY3k9IjIxIiByPSIxIj48L2NpcmNsZT48Y2lyY2xlIGN4PSIyMCIgY3k9IjIxIiByPSIxIj48L2NpcmNsZT48cGF0aCBkPSJNMSAxaDRsMi42OCAxMy4zOWEyIDIgMCAwIDAgMiAxLjYxaDEzYTIgMiAwIDAgMCAyLTEuNjFMMjMgNkg2Ij48L3BhdGg+PC9zdmc+',
                  active: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzJiYTQ3MSIgc3Ryb2tlPSIjMmJhNDcxIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iOSIgY3k9IjIxIiByPSIxIj48L2NpcmNsZT48Y2lyY2xlIGN4PSIyMCIgY3k9IjIxIiByPSIxIj48L2NpcmNsZT48cGF0aCBkPSJNMSAxaDRsMi42OCAxMy4zOWEyIDIgMCAwIDAgMiAxLjYxaDEzYTIgMiAwIDAgMCAyLTEuNjFMMjMgNkg2Ij48L3BhdGg+PC9zdmc+'
              },
              user: {
                  normal: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTIwIDIxdi0yYTQgNCAwIDAgMC00LTRoLThhNCA0IDAgMCAwLTQgNHYyIj48L3BhdGg+PGNpcmNsZSBjeD0iMTIiIGN5PSI3IiByPSI0Ij48L2NpcmNsZT48L3N2Zz4=',
                  active: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzJiYTQ3MSIgc3Ryb2tlPSIjMmJhNDcxIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTIwIDIxdi0yYTQgNCAwIDAgMC00LTRoLThhNCA0IDAgMCAwLTQgNHYyIj48L3BhdGg+PGNpcmNsZSBjeD0iMTIiIGN5PSI3IiByPSI0Ij48L2NpcmNsZT48L3N2Zz4='
              }
          }
      }
    },
    async onLoad(options) {
      // 订阅 store 变化
      const unsubscribe = store.subscribe((mutation, state) => {
        const productsStore = state.products || []
        const categoriesStore = state.categories || []
        const cartStore = state.cart || []

        if (mutation.type === 'setProducts') {
          this.localProducts = [...productsStore]
        }
        if (mutation.type === 'setCategories') {
          this.localCategories = [...categoriesStore]
        }
        if (mutation.type === 'setAgentInfo') {
          this.$forceUpdate()
        }
        if (mutation.type === 'setCart' || mutation.type === 'addToCart') {
          this.localCart = [...cartStore]
        }
        if (mutation.type === 'setSharedCart') {
          this.localSharedCart = [...state.sharedCart]
        }
        if (mutation.type === 'setCompanies') {
          this.$forceUpdate()
          // 如果没有选中公司且列表不为空，默认选第一个
          if (!store.state.selectedCompanyId && state.companies.length > 0) {
            store.commit('setCompanyId', state.companies[0].id)
          }
        }
        if (mutation.type === 'setCompanyId') {
          this.$forceUpdate()
        }
        if (mutation.type === 'setSharedCompany') {
          this.localSharedCompany = state.sharedCompanyInfo ? { ...state.sharedCompanyInfo } : null
          this.$forceUpdate()
        }
        if (mutation.type === 'setSettings') {
          this.$forceUpdate()
        }
      })
      
      this.localSharedCompany = store.state.sharedCompanyInfo ? { ...store.state.sharedCompanyInfo } : null
      
      await store.dispatch('init', { apiBase: options.apiBase })
      await store.dispatch('fetchBootstrap')
      
      // 如果已登录合作商，获取公司列表
      if (store.state.agentInfo) {
        await store.dispatch('fetchAgentCompanies')
      }

      // 增强参数提取：处理 H5 Hash 路由模式下的参数
      const getQueryParam = (name) => {
        if (typeof window === 'undefined') return null
        const url = new URL(window.location.href)
        // 1. 尝试从 search 获取 (?shareId=...)
        let val = url.searchParams.get(name)
        if (val) return val
        // 2. 尝试从 hash 获取 (#/pages/index/index?shareId=...)
        const hashPart = window.location.hash.split('?')[1]
        if (hashPart) {
          const hashParams = new URLSearchParams(hashPart)
          val = hashParams.get(name)
        }
        return val
      }

      const shareId = options.shareId || getQueryParam('shareId')

      if (shareId) {
        console.log('[Page] shareMode detected, ID:', shareId)
        this.shareId = shareId
        await store.dispatch('fetchShareConfig', shareId)
        // 获取配置后同步一次状态
        this.localSharedCart = [...store.state.sharedCart]
        this.localSharedCompany = store.state.sharedCompanyInfo ? { ...store.state.sharedCompanyInfo } : null
        // 分享模式下，普通用户默认进入画册
        this.currentTab = 'catalog'
      }
      
      // 处理微信授权回调
      if (options.code && options.state === 'agent_login') {
        try {
          wx.showLoading({ title: '登录中...', mask: true })
          
          // 调用后端 API 进行微信登录
          await store.dispatch('loginByWechat', options.code)
          
          wx.hideLoading()
          wx.showToast({ title: '登录成功', icon: 'success' })
          
          // 清除 URL 中的 code 和 state 参数
          if (typeof window !== 'undefined' && window.history) {
            const url = new URL(window.location.href)
            url.searchParams.delete('code')
            url.searchParams.delete('state')
            window.history.replaceState({}, '', url.toString())
          }
        } catch (e) {
          wx.hideLoading()
          wx.showToast({ title: e.message || '登录失败', icon: 'none' })
        }
      }
      
      // 清理订阅
      this.$on('hook:beforeDestroy', () => {
        unsubscribe()
      })
    },
    methods: {
      onNativeTabChange(e) { this.currentTab = e.currentTarget.dataset.val },
      onCategoryChange(e) { this.activeCategory = e.currentTarget.dataset.id },
      onUidInput(e) { this.loginUid = e.detail.value },
      async onLogin() {
        if (!this.loginUid) return
        wx.showLoading({ title: '登录中' })
        try {
          await store.dispatch('loginByUid', this.loginUid)
          wx.hideLoading()
          wx.showToast({ title: '登录成功', icon: 'success' })
          
          // 强制刷新界面
          this.$forceUpdate()
          
          // 清空输入框
          this.loginUid = ''
        } catch (e) {
          wx.hideLoading()
          wx.showToast({ title: e.message || '登录失败', icon: 'none' })
        }
      },
      onLogout() {
        wx.showModal({
          title: '提示',
          content: '确定要退出登录吗？',
          success: (res) => {
            if (res.confirm) store.dispatch('logout')
          }
        })
      },
      showAgentLogin() {
        // 在分享链接场景下,显示登录表单
        this.showLoginForm = true
      },
      onWechatLogin() {
        // 微信公众号网页授权登录(静默授权)
        // 获取当前页面 URL
        const currentUrl = window.location.href
        const redirectUri = encodeURIComponent(currentUrl.split('?')[0])
        
        // 构造微信授权 URL
        // 注意: APPID 需要从后端获取或配置
        // 这里使用 state 参数标记为合作商登录
        const state = 'agent_login'
        
        // 先调用后端获取授权 URL
        const apiUrl = this.apiBase + '/wechat/auth-url?redirect=' + redirectUri + '&state=' + state
        fetch(apiUrl)
          .then(res => res.json())
          .then(data => {
            if (data.authUrl) {
              // 跳转到微信授权页面
              window.location.href = data.authUrl
            } else {
              wx.showToast({ title: '获取授权链接失败', icon: 'none' })
            }
          })
          .catch(e => {
            console.error('[WeChat Auth] Error:', e)
            wx.showToast({ title: '授权失败', icon: 'none' })
          })
      },
      onAddCompany() {
        // 单公司模式:如果已有公司,不允许添加
        if (this.myCompany) {
          wx.showToast({ title: '只能添加一个公司', icon: 'none' })
          return
        }
        this.editingCompanyId = null
        this.companyForm = { name: '', contactName: '', phone: '' }
        this.showCompanyModal = true
      },
      onEditMyCompany() {
        if (!this.myCompany) return
        this.editingCompanyId = this.myCompany.id
        this.companyForm = { ...this.myCompany }
        this.showCompanyModal = true
      },
      onEditCompany(e) {
        const item = e.currentTarget.dataset.item
        this.editingCompanyId = item.id
        this.companyForm = { ...item }
        this.showCompanyModal = true
      },
      onDeleteCompany(e) {
        const id = e.currentTarget.dataset.id
        wx.showModal({
          title: '提示',
          content: '确定要删除该公司吗？',
          success: async (res) => {
            if (res.confirm) {
              await store.dispatch('deleteCompany', id)
              wx.showToast({ title: '已删除' })
            }
          }
        })
      },
      onFormInput(e) {
        const key = e.currentTarget.dataset.key
        this.companyForm[key] = e.detail.value
      },
      closeModal() { this.showCompanyModal = false },
      async submitCompany() {
        if (!this.companyForm.name) return
        wx.showLoading({ title: '保存中' })
        try {
          await store.dispatch('saveCompany', {
            ...this.companyForm,
            id: this.editingCompanyId
          })
          this.closeModal()
          wx.hideLoading()
          wx.showToast({ title: '保存成功' })
        } catch (e) {
          wx.hideLoading()
          wx.showToast({ title: '保存失败', icon: 'none' })
        }
      },
      stop() {},
      addToCart(e) {
        const id = e.currentTarget.dataset.id
        const q = parseInt(e.currentTarget.dataset.q || '1')
        store.commit('addToCart', { productId: id, quantity: q })
      },
      toggleCart(e) {
        const id = e.currentTarget.dataset.id
        const isAdded = this.cartMap[id] > 0
        if (isAdded) {
          // Remove from cart
          const items = this.localCart.filter(i => String(i.productId) !== String(id))
          store.commit('setCart', items)
        } else {
          // Add to cart (default quantity 1)
          store.commit('addToCart', { productId: id, quantity: 1 })
        }
      },
      toggleDesc(e) {
        const id = e.currentTarget.dataset.id
        this.expandedIds = {
          ...this.expandedIds,
          [id]: !this.expandedIds[id]
        }
      },
      clearCart() { store.commit('setCart', []) },
      async onShare() {
          const items = this.cart.map(i => ({ productId: i.productId, quantity: i.quantity }))
          const res = await store.dispatch('createCartShare', { items })
          const shareUrl = `https://tuce.aizhuliren.cn/?shareId=${res.id}#/pages/index/index`

          // H5 环境使用 Web API 复制
          const copyToClipboard = async (text) => {
            if (typeof navigator !== 'undefined' && navigator.clipboard) {
              try {
                await navigator.clipboard.writeText(text)
                return true
              } catch (e) {
                // fallback to execCommand
                const textarea = document.createElement('textarea')
                textarea.value = text
                textarea.style.position = 'fixed'
                textarea.style.opacity = '0'
                document.body.appendChild(textarea)
                textarea.select()
                const success = document.execCommand('copy')
                document.body.removeChild(textarea)
                return success
              }
            }
            return false
          }

          wx.showModal({
            title: '已生成清单',
            content: shareUrl,
            confirmText: '复制地址',
            success: async (modalRes) => {
              if (modalRes.confirm) {
                const copied = await copyToClipboard(shareUrl)
                if (copied) {
                  wx.showToast({ title: '已复制到剪贴板', icon: 'success' })
                } else {
                  wx.showToast({ title: '复制失败，请手动复制', icon: 'none' })
                }
              }
            }
          })
      },
      makeCall() { if (this.agentInfo?.phone) wx.makePhoneCall({ phoneNumber: this.agentInfo.phone }) }
    }
  })
</script>

<style>
  :root {
    --primary-color: #2ba471;
    --danger-color: #f5222d;
    --bg-color: #f6f7f9;
    --card-shadow: 0 4rpx 16rpx rgba(0, 0, 0, 0.05);
    --border-radius: 16rpx;
  }

  .container { height: 100vh; display: flex; flex-direction: column; background: var(--bg-color); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; }
  
  .web-navbar { height: 88rpx; background: #fff; display: flex; align-items: center; justify-content: center; position: sticky; top: 0; z-index: 100; box-shadow: 0 1rpx 0 rgba(0,0,0,0.05); flex-shrink: 0; }
  .navbar-title { font-size: 32rpx; font-weight: 600; color: #1d1d1f; }
  
  .view-content { flex: 1; display: flex; flex-direction: column; overflow: hidden; padding-bottom: 120rpx; }
  
  /* Banner Styles */
  .banner-container { width: 100%; height: 280rpx; background: #fff; flex-shrink: 0; box-shadow: 0 4rpx 12rpx rgba(0,0,0,0.03); }
  .banner-swiper { height: 100%; }
  .banner-image { width: 100%; height: 100%; }

  /* Catalog Layout */
  .catalog-layout { flex: 1; display: flex; overflow: hidden; }
  .sidebar { width: 170rpx; background: #f0f2f5; height: 100%; transition: all 0.3s; }
  .sidebar-item { padding: 34rpx 20rpx; font-size: 26rpx; text-align: center; color: #4b4b4b; position: relative; transition: color 0.2s; }
  .sidebar-item.active { background: #fff; color: var(--primary-color); font-weight: 600; }
  .sidebar-item.active::after { content: ''; position: absolute; left: 0; top: 30%; bottom: 30%; width: 6rpx; background: var(--primary-color); border-radius: 0 4rpx 4rpx 0; }
  
  .main-content { flex: 1; background: #fff; padding: 24rpx; }
  
  /* Product Cards */
  .product-item-row { margin-bottom: 24rpx; background: #fff; border-radius: var(--border-radius); padding: 20rpx; border: 1rpx solid rgba(0,0,0,0.02); box-shadow: var(--card-shadow); transition: transform 0.2s; }
  .product-item-row:active { transform: scale(0.98); }
  .prod-main-row { display: flex; gap: 24rpx; }
  .prod-img { width: 180rpx; height: 180rpx; border-radius: 12rpx; flex-shrink: 0; background: #f0f0f0; }
  .prod-info { flex: 1; display: flex; flex-direction: column; justify-content: space-between; min-width: 0; }
  .prod-name { font-size: 28rpx; font-weight: 600; color: #1d1d1f; line-height: 1.4; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  
  .prod-tags { display: flex; flex-wrap: wrap; gap: 8rpx; margin: 12rpx 0; }
  .tag { font-size: 20rpx; padding: 4rpx 12rpx; border-radius: 6rpx; background: #f2f3f5; color: #86909c; }
  .tag.primary { background: #e8f3ff; color: var(--primary-color); }
  .tag.red { background: #fff1f0; color: var(--danger-color); }
  .tag.oem { background: #fef4e6; color: #ff9500; }
  
  .prod-desc-container { margin: 12rpx 0; position: relative; }
  .prod-desc { font-size: 24rpx; color: #4e5969; line-height: 1.6; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; transition: all 0.3s; }
  .prod-desc.expanded { -webkit-line-clamp: initial; display: block; }
  .expand-btn { font-size: 22rpx; color: var(--primary-color); margin-top: 8rpx; display: inline-block; font-weight: 500; }
  
  .prod-bottom { display: flex; justify-content: space-between; align-items: center; margin-top: 16rpx; }
  .price-box { color: var(--danger-color); }
  .unit { font-size: 22rpx; margin-right: 2rpx; }
  .price { font-size: 36rpx; font-weight: 700; letter-spacing: -1rpx; }
  
  /* Gallery Toggle Button */
  .btn-toggle { font-size: 24rpx; padding: 12rpx 28rpx; border-radius: 30rpx; background: #f2f3f5; color: #4e5969; transition: all 0.2s; border: 1rpx solid transparent; }
  .btn-toggle.active { background: #e3f9e9; color: var(--primary-color); border-color: var(--primary-color); }
  .btn-toggle:active { opacity: 0.8; transform: scale(0.95); }
  
  /* Cart List Styling */
  .cart-scroll-list { flex: 1; padding: 24rpx; }
  .cart-item { background: #fff; border-radius: var(--border-radius); padding: 24rpx; margin-bottom: 24rpx; display: flex; gap: 24rpx; box-shadow: var(--card-shadow); border: 1rpx solid rgba(0,0,0,0.02); }
  .cart-img { width: 140rpx; height: 140rpx; border-radius: 12rpx; flex-shrink: 0; }
  .cart-info { flex: 1; display: flex; flex-direction: column; justify-content: space-between; min-width: 0; }
  .cart-name { font-size: 28rpx; font-weight: 600; color: #1d1d1f; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .cart-spec { font-size: 24rpx; color: #86909c; margin-top: 4rpx; }
  .cart-price-row { display: flex; justify-content: space-between; align-items: center; margin-top: 12rpx; }
  .c-price { font-size: 30rpx; font-weight: 700; color: var(--danger-color); }
  .btn-delete { font-size: 24rpx; color: #86909c; padding: 10rpx 20rpx; background: #f2f3f5; border-radius: 8rpx; }
  .btn-delete:active { background: #e5e6eb; }
  
  /* Cart Footer */
  .cart-footer { position: fixed; bottom: 120rpx; left: 24rpx; right: 24rpx; height: 110rpx; background: rgba(255, 255, 255, 0.96); backdrop-filter: blur(20rpx); border-radius: 24rpx; display: flex; align-items: center; justify-content: space-between; padding: 0 32rpx; box-shadow: 0 -8rpx 24rpx rgba(0,0,0,0.08); z-index: 1000; border: 1rpx solid rgba(255,255,255,0.8); }
  .cart-footer .total { display: flex; align-items: baseline; gap: 8rpx; flex-shrink: 0; }
  .footer-actions { display: flex; gap: 16rpx; align-items: center; }
  
  .btn { height: 74rpx; padding: 0 40rpx; border-radius: 37rpx; font-size: 26rpx; font-weight: 600; display: flex; align-items: center; justify-content: center; white-space: nowrap; }
  .btn.default { background: #f2f3f5; color: #4e5969; margin-right: 16rpx; }
  .btn.primary { background: var(--primary-color); color: #fff; box-shadow: 0 4rpx 12rpx rgba(43, 164, 113, 0.2); }
  .btn:active { transform: translateY(2rpx); opacity: 0.9; }
  .btn.disabled { background: #e5e6eb; color: #86909c; box-shadow: none; pointer-events: none; }
  
  /* Tab Bar */
  .custom-tab-bar { position: fixed; bottom: 0; left: 0; right: 0; height: 110rpx; background: #fff; display: flex; padding-bottom: env(safe-area-inset-bottom); z-index: 2000; box-shadow: 0 -1rpx 0 rgba(0,0,0,0.05); }
  .tab-item { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6rpx; }
  .tab-item.active .tab-text { color: var(--primary-color); font-weight: 600; }
  .tab-icon-wrapper { position: relative; width: 44rpx; height: 44rpx; }
  .tab-icon-img { width: 44rpx; height: 44rpx; transition: transform 0.2s; }
  .tab-item:active .tab-icon-img { transform: scale(0.9); }
  .tab-text { font-size: 20rpx; color: #86909c; }
  .badge { position: absolute; top: -10rpx; right: -18rpx; min-width: 32rpx; height: 32rpx; background: var(--danger-color); color: #fff; font-size: 18rpx; font-weight: 700; border-radius: 16rpx; display: flex; align-items: center; justify-content: center; padding: 0 6rpx; border: 4rpx solid #fff; box-shadow: 0 2rpx 4rpx rgba(245, 34, 45, 0.2); }
  
  .empty-state { flex: 1; display: flex; align-items: center; justify-content: center; color: #86909c; font-size: 28rpx; padding-top: 160rpx; }
  .no-more { padding: 48rpx; text-align: center; color: #c9cdd4; font-size: 24rpx; }
  
  /* Profile Page */
  .contact-container { padding: 32rpx; }
  .agent-card { background: #fff; border-radius: 24rpx; padding: 40rpx; display: flex; align-items: center; gap: 32rpx; box-shadow: var(--card-shadow); margin-bottom: 32rpx; }
  .agent-logo { width: 104rpx; height: 104rpx; border-radius: 50%; background: var(--primary-color); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 44rpx; font-weight: bold; }
  .agent-name { font-size: 34rpx; font-weight: 700; color: #1d1d1f; }
  .agent-desc { font-size: 24rpx; color: #86909c; margin-top: 4rpx; }
  .info-group { background: #fff; border-radius: 20rpx; overflow: hidden; box-shadow: var(--card-shadow); }
  .info-item { padding: 32rpx; display: flex; justify-content: space-between; align-items: center; border-bottom: 1rpx solid #f2f3f5; transition: background 0.2s; }
  .info-item:active { background: #f9f9f9; }
  .info-item:last-child { border-bottom: none; }
  .info-item .label { font-size: 28rpx; color: #4e5969; }
  .info-item .value { font-size: 28rpx; font-weight: 500; color: #1d1d1f; }
  .info-item .value.link { color: var(--primary-color); }

  .section-title { font-size: 24rpx; color: #86909c; font-weight: 600; margin: 32rpx 0 16rpx 12rpx; text-transform: uppercase; letter-spacing: 1rpx; }
  .company-item { transition: all 0.2s; }
  .company-item.active { background: #e8f3ff; }
  .company-item.active .company-name { color: var(--primary-color); font-weight: 600; }
  .check-icon { color: var(--primary-color); font-weight: bold; margin-left: auto; }

  /* Login Styles */
  .login-section { padding: 80rpx 40rpx; display: flex; flex-direction: column; align-items: center; }
  .login-header { text-align: center; margin-bottom: 80rpx; }
  .login-logo { width: 120rpx; height: 120rpx; background: var(--primary-color); color: #fff; border-radius: 30rpx; display: flex; align-items: center; justify-content: center; font-size: 60rpx; font-weight: bold; margin: 0 auto 32rpx; box-shadow: 0 8rpx 24rpx rgba(43, 164, 113, 0.2); }
  .login-title { font-size: 40rpx; font-weight: 700; color: #1d1d1f; margin-bottom: 16rpx; }
  .login-subtitle { font-size: 26rpx; color: #86909c; }
  .login-form { width: 100%; }
  .login-input { width: 100%; box-sizing: border-box; background: #fff; height: 100rpx; border-radius: 20rpx; padding: 0 32rpx; font-size: 30rpx; margin-bottom: 32rpx; box-shadow: var(--card-shadow); border: 2rpx solid transparent; transition: all 0.2s; }
  .login-input:focus { border-color: var(--primary-color); background: #fff; }
  .login-btn { height: 100rpx; background: var(--primary-color); color: #fff; border-radius: 20rpx; display: flex; align-items: center; justify-content: center; font-size: 32rpx; font-weight: 600; transition: all 0.2s; }
  .login-btn:active { transform: translateY(2rpx); opacity: 0.9; }
  .login-btn.disabled { background: #e5e6eb; color: #86909c; pointer-events: none; }
  
  /* Login Divider */
  .login-divider { display: flex; align-items: center; margin: 48rpx 0; }
  .divider-line { flex: 1; height: 1rpx; background: #e5e6eb; }
  .divider-text { padding: 0 24rpx; font-size: 24rpx; color: #86909c; }
  
  /* WeChat Login */
  .wechat-login-btn { height: 100rpx; background: #fff; border: 2rpx solid #07C160; color: #07C160; border-radius: 20rpx; display: flex; align-items: center; justify-content: center; gap: 16rpx; font-size: 32rpx; font-weight: 600; transition: all 0.2s; }
  .wechat-login-btn:active { background: #f0fdf4; transform: translateY(2rpx); }
  .wechat-icon { width: 48rpx; height: 48rpx; }


  /* Company Management */
  .section-header { display: flex; justify-content: space-between; align-items: center; margin: 32rpx 12rpx 20rpx; }
  .add-btn { font-size: 26rpx; color: var(--primary-color); font-weight: 600; border: 2rpx solid var(--primary-color); padding: 8rpx 24rpx; border-radius: 12rpx; }
  .company-main { flex: 1; }
  .company-sub { font-size: 24rpx; color: #86909c; margin-top: 4rpx; }
  .company-actions { display: flex; align-items: center; gap: 20rpx; }
  .action-btn { font-size: 24rpx; color: var(--primary-color); padding: 10rpx; }
  .action-btn.danger { color: var(--danger-color); }
  .empty-company { padding: 100rpx 0; text-align: center; }
  .empty-text { font-size: 28rpx; color: #c9cdd4; }
  
  /* Shared Company Card */
  .shared-company-card { background: #fff; border-radius: 24rpx; padding: 40rpx; box-shadow: var(--card-shadow); margin-bottom: 32rpx; }
  .shared-company-card .card-header { display: flex; align-items: center; gap: 24rpx; }
  .shared-company-card .company-logo { width: 88rpx; height: 88rpx; border-radius: 50%; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 40rpx; font-weight: bold; }
  .shared-company-card .company-name { font-size: 32rpx; font-weight: 700; color: #1d1d1f; margin-bottom: 8rpx; }
  .shared-company-card .company-desc { font-size: 24rpx; color: #86909c; }
  
  /* Agent Login Prompt */
  .agent-login-prompt { text-align: center; padding: 60rpx 40rpx; }
  .agent-login-prompt .prompt-text { font-size: 26rpx; color: #86909c; margin-bottom: 24rpx; }
  .login-btn-secondary { display: inline-block; padding: 20rpx 48rpx; background: #fff; color: var(--primary-color); border: 2rpx solid var(--primary-color); border-radius: 48rpx; font-size: 28rpx; font-weight: 600; transition: all 0.2s; }
  .login-btn-secondary:active { background: #f0f7ff; }
  
  .navbar-action { position: absolute; right: 32rpx; font-size: 28rpx; color: #86909c; }

  /* Modal */
  .modal-mask { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); z-index: 3000; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(4rpx); }
  .modal-content { width: 620rpx; background: #fff; border-radius: 32rpx; overflow: hidden; animation: modalIn 0.3s ease-out; }
  @keyframes modalIn { from { transform: translateY(40rpx); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
  .modal-header { padding: 40rpx 40rpx 20rpx; font-size: 34rpx; font-weight: 700; display: flex; justify-content: space-between; align-items: center; }
  .close-icon { font-size: 48rpx; color: #c9cdd4; padding: 10rpx; line-height: 1; }
  .modal-body { padding: 20rpx 40rpx 40rpx; }
  .form-item { margin-bottom: 32rpx; }
  .form-label { font-size: 26rpx; color: #4e5969; margin-bottom: 12rpx; display: block; }
  .form-input { width: 100%; box-sizing: border-box; height: 90rpx; background: #f2f3f5; border-radius: 16rpx; padding: 0 24rpx; font-size: 28rpx; border: 2rpx solid transparent; transition: all 0.2s; }
  .form-input:focus { border-color: var(--primary-color); background: #fff; }
  .modal-footer { padding: 20rpx 40rpx 40rpx; display: flex; gap: 24rpx; }
  .modal-footer .btn { flex: 1; height: 90rpx; border-radius: 20rpx; }
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/lib/components/button/button"
    }
  }
</script>
